import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { CreateBranchForm } from '~/features/CreateBranchForm';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[{ label: '事業所', href: ROUTES.BRANCHES.INDEX }, { label: '新規追加' }]}
      />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <CreateBranchForm />
        </Suspense>
      </main>
    </div>
  </div>
);
